import React, { Fragment } from 'react'

import Modal from 'react-modal'

import PropTypes from 'prop-types'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import CopyToClipboard from './CopyTextOnClick'
import Icon from './Icon/Icon'
import SocialButtons from './SocialButtons'

const DEFAULT_SOCIAL_NETWORKS = ['facebook', 'linkedin', 'twitter']

function ShareModal({
  url,
  closeModal,
  showSocial = false,
  socialTitle = 'Share on',
  socialNetworks = DEFAULT_SOCIAL_NETWORKS,
  title = '',
  subTitle = '',
  headerIcon = EMPTY_ARRAY,
}) {
  function flashSuccess(e) {
    e.preventDefault()
    App.events.publish('app:notification:flash:success', 'Your link has been copied!')
  }

  return (
    <Modal
      isOpen
      shouldCloseOnOverlayClick
      onRequestClose={closeModal}
      contentLabel="Share"
      ariaHideApp={false}
      className={{
        base: '',
        afterOpen: 'overlay-modal--container_after-open overlay-modal-container--xs',
        beforeClose: 'overlay-modal--container_before-close',
      }}
      overlayClassName={{
        base: 'overlay-modal--background',
        afterOpen: 'overlay-modal--background_after-open',
        beforeClose: 'overlay-modal--background_before-close',
      }}
    >
      <div className="overlay-modal share-modal" onClick={(e) => e.stopPropagation()}>
        <button id="close-job-share-modal" className="btn btn-transparent overlay-modal--close-inner" onClick={closeModal}>
          <Icon type={['fal', 'times']} color="grey-dark" />
        </button>
        <div className="overlay-modal--content overlay-modal--jobs">
          {(title || subTitle || headerIcon.length > 0) && (
            <div className="share-modal__header">
              {headerIcon.length > 0 && (
                <Icon type={headerIcon} size="5x" color="green-dark" />
              )}
              {title && (
                <h2 className="heading-40">{title}</h2>
              )}
              {subTitle && (
                <h3 className="heading-18">{subTitle}</h3>
              )}
            </div>
          )}

          {showSocial && (
            <Fragment>
              <p className="share-modal__heading">{socialTitle}:</p>

              <SocialButtons
                socialNetworks={socialNetworks}
                page="Footer"
                className="social-icon-circle--xlarge social-icon-circle--outline"
                url={url}
                share
              />
            </Fragment>
          )}

          <p className="share-modal__heading">
            {showSocial ? 'Or copy direct link below:' : 'Copy direct link below and share:'}
          </p>

          <div className="form-inline form-group form-group-grey">
            <input className="form-control form-control-grey u-mr10" type="text" name="shareable-url" defaultValue={url} />

            <CopyToClipboard text={url} id="copy-shareable-link">
              <button className="btn btn-primary" onClick={flashSuccess}>Copy</button>
            </CopyToClipboard>
          </div>
        </div>
      </div>
    </Modal>
  )
}

ShareModal.propTypes = {
  url: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  showSocial: PropTypes.bool,
  socialTitle: PropTypes.string,
  showDirectCopyUrl: PropTypes.bool,
  socialNetworks: PropTypes.array,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  headerIcon: PropTypes.array,
}

export default ShareModal
